import { Switch } from "@headlessui/react";
import React, { useEffect, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { toast } from "react-toastify";
type Props = {
  disabled?: boolean;
  register: any;
  setValue: any;
  name: string;
  value: boolean;
};

const SwitchButton = (props: Props) => {
  const { value = false, disabled = false, register, setValue, name } = props;
  const [toggleValue, setToggleValue] = useState(false);
  useEffect(() => {
    setToggleValue(value);
  }, [value, setToggleValue]);
  const handleOnChange = (e) => {
    if (!disabled) {
      setValue(name, e);
      setToggleValue(e);
    } else {
      toast.error("Please remove all Orders from Boxes to continue...");
    }
  };

  return (
    <>
      <Switch
        checked={toggleValue}
        {...register}
        onChange={handleOnChange}
        // disabled={disabled}
        className={tw`${toggleValue ? tw`bg-[#68D391]` : tw`bg-gray-300`}
          relative inline-flex h-5 w-8 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-primary focus-visible:ring-opacity-75`}
      >
        <span className={tw`sr-only`}>Use setting</span>
        <span
          aria-hidden="true"
          className={tw`${toggleValue ? tw`translate-x-3` : tw`translate-x-0`}
            pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </>
  );
};

export default SwitchButton;
